import { render } from "./NsiCountryCoverageCard.vue?vue&type=template&id=35e2c29a"
import script from "./NsiCountryCoverageCard.vue?vue&type=script&lang=js"
export * from "./NsiCountryCoverageCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__